import { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import ReactSelect from 'react-select'
import AddIcon from '../../assets/AddIcon'
import BarcodeIcon from '../../assets/BarcodeIcon'
import CloseIcon from '../../assets/CloseIcon'
import DamageLossBlack from '../../assets/DamageLossBlack'
import SortIcon from '../../assets/SortIcon'
import TrashIcon from '../../assets/TrashIcon'
import {
  HEADER_CONFIG,
  HEADER_CONST,
} from '../../common/constant/common-constant'
import {
  DAMAGE_LOSS_FIELDS,
  PAGE_CONST,
  PERMISSION_FEATURE,
  PERMISSION_SCREEN,
  PERMISSION_TYPE,
  PRODUCT_CATEGORY,
  PRODUCT_DETAIL_FIELDS,
} from '../../common/constant/page-constant'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import { formatDate } from '../../common/utils/appUtils'
import { redirect } from '../../common/utils/redirectionUtils'
import Alert from '../../components/Alert/Alert'
import BarcodeScanner from '../../components/ZXingScanner/BarcodeScanner'
import {
  addDamageLossAdjustmentHelper,
  deleteDamageLossAdjustmentHelper,
  updateDamageLossAdjustmentHelper,
  getDamageLossAdjustmentHelper,
  getProductDetailsByBarcodeHelper,
} from '../../helper/home-helper'
import {
  getProductDetailByIdHelper,
  getProductSearchSuggestionsHelper,
} from '../../helper/personal-details-helper'
import { addDamageLossAlertAction } from '../../modules/actions/action'
import Card from '../Common/Card/Card'
import MobileHeader from '../Common/Header/MobileHeader'
import PopupCard from '../Common/PopupCard/PopupCard'
import SideDrawer from '../Common/SideDrawer/SideDrawer'

import currencyFormatter from './../../common/utils/currencyFormatterUtils'
import './DamageLoss.scss'

const DamageLoss = (props) => {
  const navigate = useNavigate()
  const isMobile = useCheckMobileScreen()

  const [viewDrawer, setViewDrawer] = useState(false)
  const [open, setOpen] = useState(false)
  const [isSorting, setIsSorting] = useState(false)
  const [productData, setProductData] = useState(undefined)
  const [damageLossData, setDamageLossData] = useState(undefined)
  const [managedDamageLossData, setManagedDamageLossData] = useState(undefined)
  const [groupedDamageLossData, setGroupedDamageLossData] = useState([])
  const [isFieldErrorVisible, setIsFieldErrorVisible] = useState(false)
  const [serverError, setServerError] = useState(undefined)
  const [addDamageLossAlert, setAddDamageLossAlert] = useState(false)
  const [headerOptions, setHeaderOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
    [HEADER_CONFIG.TITLE]: HEADER_CONST.DAMAGE_LOSS_ADJUSTMENT,
    [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => redirect(navigate, PAGE_CONST.HOME),
  })

  const [searchTerm, setSearchTerm] = useState('')
  const [selectedSearchTerm, setSelectedSearchTerm] = useState(undefined)
  const [searchSuggestions, setSearchSuggestions] = useState([])
  const searchTimerRef = useRef(null)
  const searchAbortRef = useRef(null)
  const [isScannerVisible, setIsScannerVisible] = useState(false)
  const [permissions, setPermissions] = useState({})
  const [productsList, setProductsList] = useState([])
  const [viewMode, setViewMode] = useState(false)
  const [selectedChallanData, setSelectedChallanData] = useState(null)
  const [editChallanData, setEditChallanData] = useState(null)
  const [originalChallanNumber, setOriginalChallanNumber] = useState('')
  const [challanNumberError, setChallanNumberError] = useState('')
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    let addDamageLossAlert = props.alert?.addDamageLossAlert
    setAddDamageLossAlert(addDamageLossAlert)
  }, [props.alert?.addDamageLossAlert])

  useEffect(() => {
    getDamageLossAdjustmentData()
  }, [])

  useEffect(() => {
    if (!open) {
      handleHeaderConfigUpdate(HEADER_CONST.DAMAGE_LOSS_ADJUSTMENT, () =>
        redirect(navigate, PAGE_CONST.HOME)
      )
      return
    }

    handleHeaderConfigUpdate(HEADER_CONST.ADD_DAMAGE_LOSS_ADJUSTMENT, () =>
      handleDrawerToggle()
    )
  }, [open])

  useEffect(() => {
    handleSearchSuggestions(searchTerm)
    return () => clearTimeout(searchTimerRef.current)
  }, [searchTerm])

  useEffect(() => {
    if (selectedSearchTerm) {
      handleSearch(selectedSearchTerm)
    }
  }, [selectedSearchTerm])

  useEffect(() => {
    if (props.loginData.permissions) {
      let permission = props.loginData.permissions.filter(
        (permission) => permission.screen === PERMISSION_SCREEN.MANAGE_STORE
      )[0]

      if (permission) setPermissions(permission)
    }
  }, [props.loginData])

  const handleSearchSuggestions = (searchTerm) => {
    if (searchAbortRef.current) {
      searchAbortRef.current.abort()
    }
    if (searchTimerRef.current) {
      clearTimeout(searchTimerRef.current)
    }

    if (!searchTerm || searchTerm?.length === 0) {
      clearSearchData()
      return
    }

    searchTimerRef.current = setTimeout(() => {
      const abortController = new AbortController()
      searchAbortRef.current = abortController

      getProductSearchSuggestionsHelper(searchTerm, abortController.signal)
        .then((results) => {
          if (abortController.signal.aborted) return
          setSearchSuggestions(results)
        })
        .catch(() => {})
    }, 500)
  }

  const handleSearch = async () => {
    try {
      let data = await getProductDetailByIdHelper(selectedSearchTerm)

      // setSearchResults(data)
      setProductData(data)

      setDamageLossData((damageLossData) => {
        return {
          ...damageLossData,
          [DAMAGE_LOSS_FIELDS.BARCODE]:
            data?.[PRODUCT_DETAIL_FIELDS.PRODUCT_BARCODE],
        }
      })
    } catch (err) {}
  }

  const clearSearchData = () => {
    setSearchSuggestions([])
    setSelectedSearchTerm(undefined)
    if (searchAbortRef.current) searchAbortRef.current.abort()
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current)
  }

  const handleHeaderConfigUpdate = (title, handleBackFunc) => {
    setHeaderOptions({
      [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
      [HEADER_CONFIG.TITLE]: title,
      [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => handleBackFunc(),
    })
  }

  const getDamageLossAdjustmentData = () => {
    getDamageLossAdjustmentHelper()
      .then((res) => {
        console.log('mc res: ', res)
        setManagedDamageLossData(res)
        
        // Group data by challan number
        const grouped = groupByChallanNumber(res)
        setGroupedDamageLossData(grouped)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const groupByChallanNumber = (data) => {
    if (!data || !Array.isArray(data)) return []
    
    const groupedMap = data.reduce((acc, item) => {
      const challanNumber = item.challan_number
      if (!acc[challanNumber]) {
        acc[challanNumber] = {
          challan_number: challanNumber,
          created_at: item.created_at,
          notes: item.notes,
          products: [],
          totalAmount: 0,
        }
      }
      acc[challanNumber].products.push(item)
      acc[challanNumber].totalAmount += parseFloat(item.amount || 0)
      return acc
    }, {})
    
    return Object.values(groupedMap)
  }

  const checkChallanNumberExists = (challanNumber) => {
    if (!challanNumber || !groupedDamageLossData) return false
    return groupedDamageLossData.some(
      (item) => item.challan_number.toLowerCase() === challanNumber.toLowerCase()
    )
  }

  const handleChallanNumberChange = (value) => {
    handleDamageLossDetailUpdate(DAMAGE_LOSS_FIELDS.CHALLAN_NUMBER, value)
    
    // Check if challan number already exists (only in add mode, not view mode)
    if (!viewMode && checkChallanNumberExists(value)) {
      setChallanNumberError('Challan number already exists. Please use a different one.')
    } else {
      setChallanNumberError('')
    }
  }

  const handleCardClick = (challanData) => {
    setSelectedChallanData(challanData)
    setEditChallanData({
      challan_number: challanData.challan_number,
      notes: challanData.notes,
      products: challanData.products.map(p => ({
        ...p,
        quantity: p.quantity
      }))
    })
    setOriginalChallanNumber(challanData.challan_number)
    setViewMode(true)
    setViewDrawer(true)
    setOpen(true)
  }

  const handleCloseViewDrawer = () => {
    setViewMode(false)
    setSelectedChallanData(null)
    setEditChallanData(null)
    setOriginalChallanNumber('')
    setViewDrawer(false)
    setOpen(false)
    setShowDeleteConfirm(false)
    setServerError(undefined)
  }

  const handleEditChallanNumberChange = (value) => {
    setEditChallanData(prev => ({
      ...prev,
      challan_number: value
    }))
    
    // Check if challan number already exists (exclude current one)
    if (value !== originalChallanNumber && checkChallanNumberExists(value)) {
      setChallanNumberError('Challan number already exists. Please use a different one.')
    } else {
      setChallanNumberError('')
    }
  }

  const handleEditNotesChange = (value) => {
    setEditChallanData(prev => ({
      ...prev,
      notes: value
    }))
  }

  const handleEditProductQuantity = (productIndex, newQuantity) => {
    setEditChallanData(prev => ({
      ...prev,
      products: prev.products.map((p, idx) => 
        idx === productIndex ? { ...p, quantity: newQuantity } : p
      )
    }))
  }

  const handleSaveDamageLoss = () => {
    if (!editChallanData?.challan_number || !editChallanData?.notes) {
      setServerError('Please fill in all required fields')
      return
    }
    
    if (challanNumberError) {
      return
    }
    
    setIsSaving(true)
    setServerError(undefined)
    
    const updateData = {
      original_challan_number: originalChallanNumber,
      challan_number: editChallanData.challan_number,
      notes: editChallanData.notes,
      products: editChallanData.products.map(p => ({
        damage_loss_adjustment_id: p.damage_loss_adjustment_id,
        quantity: parseInt(p.quantity)
      }))
    }
    
    updateDamageLossAdjustmentHelper(updateData)
      .then(() => {
        getDamageLossAdjustmentData()
        handleCloseViewDrawer()
        props.addDamageLossAlertAction(true)
        setTimeout(() => {
          props.addDamageLossAlertAction(false)
        }, 5000)
      })
      .catch((err) => {
        setServerError(err)
      })
      .finally(() => {
        setIsSaving(false)
      })
  }

  const handleDeleteDamageLoss = () => {
    if (!originalChallanNumber) return
    
    setIsDeleting(true)
    deleteDamageLossAdjustmentHelper(originalChallanNumber)
      .then(() => {
        getDamageLossAdjustmentData()
        handleCloseViewDrawer()
        props.addDamageLossAlertAction(true)
        setTimeout(() => {
          props.addDamageLossAlertAction(false)
        }, 5000)
      })
      .catch((err) => {
        setServerError(err)
      })
      .finally(() => {
        setIsDeleting(false)
        setShowDeleteConfirm(false)
      })
  }

  const handleDrawerToggle = () => {
    if (open) {
      // Closing drawer
      setViewMode(false)
      setSelectedChallanData(null)
      setChallanNumberError('')
    }
    setViewDrawer(!viewDrawer)
    setOpen(!open)
  }

  const getProductDetailsByBarcode = (bCode) => {
    setServerError('')

    let barCode = bCode || damageLossData?.[DAMAGE_LOSS_FIELDS.BARCODE]
    if (!barCode) {
      return
    }
    getProductDetailsByBarcodeHelper(barCode)
      .then((res) => {
        setProductData(undefined)
        if (res) setProductData(res)
      })
      .catch((err) => {
        setServerError(err)
        setProductData(undefined)
        setDamageLossData({
          ...damageLossData,
          [PRODUCT_DETAIL_FIELDS.PRODUCT_BARCODE]: barCode,
          [PRODUCT_DETAIL_FIELDS.SELECTED_BATCH_DETAILS]: undefined,
          product_batch_inventory_id: undefined,
        })
        // console.log("")
      })
  }

  const handleDamageLossDetailUpdate = (key, value) => {
    setDamageLossData((damageLossData) => {
      return {
        ...damageLossData,
        [key]: value,
      }
    })
  }

  const checkProductValidation = () => {
    if (
      damageLossData?.[DAMAGE_LOSS_FIELDS.BARCODE] &&
      damageLossData?.[DAMAGE_LOSS_FIELDS.QUANTITY] &&
      damageLossData?.product_batch_inventory_id &&
      parseInt(damageLossData?.[PRODUCT_DETAIL_FIELDS.QUANTITY]) <=
        parseInt(
          damageLossData?.[PRODUCT_DETAIL_FIELDS.SELECTED_BATCH_DETAILS]?.[
            PRODUCT_DETAIL_FIELDS.STOCK
          ]
        )
    ) {
      return true
    }
    return false
  }

  const checkValidation = () => {
    if (
      damageLossData?.[DAMAGE_LOSS_FIELDS.CHALLAN_NUMBER] &&
      damageLossData?.[DAMAGE_LOSS_FIELDS.NOTES] &&
      productsList.length > 0 &&
      !challanNumberError
    ) {
      return true
    }

    return false
  }

  const handleAddProductToList = () => {
    if (!checkProductValidation()) {
      setIsFieldErrorVisible(true)
      return
    }
    setIsFieldErrorVisible(false)

    const newProduct = {
      id: Date.now(),
      damageLossData: { ...damageLossData },
      productData: { ...productData },
    }

    setProductsList((prev) => [...prev, newProduct])

    // Reset product fields but keep challan number and notes
    setDamageLossData((prev) => ({
      [DAMAGE_LOSS_FIELDS.CHALLAN_NUMBER]: prev?.[DAMAGE_LOSS_FIELDS.CHALLAN_NUMBER],
      [DAMAGE_LOSS_FIELDS.NOTES]: prev?.[DAMAGE_LOSS_FIELDS.NOTES],
    }))
    setProductData(undefined)
    setSearchTerm('')
    setSelectedSearchTerm(undefined)
    setSearchSuggestions([])
  }

  const handleRemoveProductFromList = (productId) => {
    setProductsList((prev) => prev.filter((item) => item.id !== productId))
  }

  const getTotalDamageLossAmount = () => {
    let total = 0
    productsList.forEach((item) => {
      const cost = item.productData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_NEW_COST] || 0
      const qty = item.damageLossData?.[DAMAGE_LOSS_FIELDS.QUANTITY] || 0
      total += cost * qty
    })
    // Add current product if exists
    if (productData && productData.cost_per_unit && damageLossData?.[DAMAGE_LOSS_FIELDS.QUANTITY]) {
      total += productData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_NEW_COST] * damageLossData?.[DAMAGE_LOSS_FIELDS.QUANTITY]
    }
    return total
  }

  const handleSubmit = async () => {
    if (!checkValidation()) {
      setIsFieldErrorVisible(true)
      return
    }

    setIsFieldErrorVisible(false)

    const challanNumber = damageLossData?.[DAMAGE_LOSS_FIELDS.CHALLAN_NUMBER]
    const notes = damageLossData?.[DAMAGE_LOSS_FIELDS.NOTES]

    // Submit all products in the list
    for (const item of productsList) {
      const data = {
        damageLossData: {
          ...item.damageLossData,
          [DAMAGE_LOSS_FIELDS.CHALLAN_NUMBER]: challanNumber,
          [DAMAGE_LOSS_FIELDS.NOTES]: notes,
        },
        productData: item.productData,
      }

      await addDamageLossAdjustmentHelper(data).catch((err) => {
        setServerError(err)
      })
    }

    props.addDamageLossAlertAction(true)

    setTimeout(() => {
      props.addDamageLossAlertAction(false)
    }, 5000)
    getDamageLossAdjustmentData()
    resetDrawerData()
    handleDrawerToggle()
  }

  const resetDrawerData = () => {
    setDamageLossData(undefined)
    setProductData(undefined)
    setProductsList([])
    setSearchTerm('')
    setSelectedSearchTerm(undefined)
    setSearchSuggestions([])
    setChallanNumberError('')
    setViewMode(false)
    setSelectedChallanData(null)
    setEditChallanData(null)
    setOriginalChallanNumber('')
    setShowDeleteConfirm(false)
  }

  const handleScan = (result) => {
    if (result) {
      console.log('result in handleScan: ', result)
      // setScannedResult(result)
      handleDamageLossDetailUpdate(
        PRODUCT_DETAIL_FIELDS.PRODUCT_BARCODE,
        result
      )
      setIsScannerVisible(false) // Hide the scanner after a successful scan

      getProductDetailsByBarcode(result)
    }
  }

  return (
    <>
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      {addDamageLossAlert && (
        <Alert
          success
          alertType="success"
          alertMessage="New Damage/Loss Adjustment added Successfully!"
        />
      )}
      <div className="pageBodyRightPanel DamageLoss">
        {isMobile &&
          permissions?.features?.[PERMISSION_FEATURE.DAMAGE_LOSS] ===
            PERMISSION_TYPE.MANAGE && (
            <div className="addProductBtnMobile dFlex flexColumnReverse aiCenter mwebVisible fixed">
              <button
                className="animated zoomIn btn btnPrimary"
                onClick={handleDrawerToggle}
              >
                <AddIcon />
              </button>
              <button
                className="animated zoomIn btn btnSecondary pointer mb-2"
                onClick={() => setIsSorting(true)}
              >
                <SortIcon />
              </button>
            </div>
          )}
        {!isMobile && (
          <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter">
            <div className="pageBodyRightPanelHeading">
              Damage/Loss Adjustment
            </div>
            <div className="addProductBtn dFlex aiCenter">
              {permissions?.features?.[PERMISSION_FEATURE.DAMAGE_LOSS] ===
                PERMISSION_TYPE.MANAGE && (
                <button className="btn btnPrimary" onClick={handleDrawerToggle}>
                  ADD
                </button>
              )}
              <div className="pointer ml-4" onClick={() => setIsSorting(true)}>
                <SortIcon />
              </div>
              <div className="pointer ml-4" onClick={() => props.onClose()}>
                <CloseIcon />
              </div>
            </div>
          </div>
        )}
        <div className="productLlistWrap dFlex">
          {groupedDamageLossData &&
            groupedDamageLossData.map((challanData, index) => {
              const productNames = challanData.products
                .map((p) => `${p.product_name}${p.dose ? ` (${p.dose})` : ''}`)
                .join(', ')
              const totalQty = challanData.products.reduce((sum, p) => sum + parseInt(p.quantity || 0), 0)
              
              return (
                <div className="cardWrap" key={`challan-${index}`}>
                  <Card
                    handleClick={() => handleCardClick(challanData)}
                    product={{
                      productName: challanData.products.length > 1 
                        ? `${challanData.products.length} Products` 
                        : productNames,
                      quantity: totalQty,
                    }}
                    productDesc={challanData?.notes}
                    headerSup={formatDate(challanData?.created_at)}
                    headerMain={challanData.challan_number}
                    cardRight={`BDT ${currencyFormatter(challanData.totalAmount || 0)}`}
                  />
                </div>
              )
            })}
        </div>
        {/* side drawer for filter and sorting  */}
        <SideDrawer
          handleDrawerToggle={() => setIsSorting(!isSorting)}
          open={isSorting}
          drawerButton={true}
          drawerHeading="Sort"
          mwebSideDrawerFooter
        >
          <form className="mt-5">
            <div className="formGroup formFloating">
              <select className="formSelect" id="floatingSelect">
                <option value="none" selected disabled hidden>
                  Quantity
                </option>
                <option value="1">1</option>
                <option value="2">2</option>
              </select>
              <label for="floatingSelect">Quantity</label>
              {false && (
                <div class="invalidFeedback">Please choose Quantity.</div>
              )}
            </div>
            <div className="formGroup formFloating">
              <select className="formSelect" id="floatingSelect">
                <option value="none" selected disabled hidden>
                  Amount
                </option>
                <option value="1">1</option>
                <option value="2">2</option>
              </select>
              <label for="floatingSelect">Amount</label>
              {false && (
                <div class="invalidFeedback">Please choose Amount.</div>
              )}
            </div>
          </form>
        </SideDrawer>
        <SideDrawer
          handleDrawerToggle={viewMode ? handleCloseViewDrawer : handleDrawerToggle}
          open={open}
          drawerButton={!viewMode}
          drawerHeading={viewMode ? "Edit Damage/Loss" : "Add Damage/Loss"}
          handleClick={viewMode ? undefined : () => handleSubmit()}
        >
          {viewMode && selectedChallanData && editChallanData ? (
            // Edit Mode Content
            <div className="editModeContent">
              {serverError && (
                <div class="invalidFeedback mb-4">{serverError}</div>
              )}
              <div className="consolidateStrip dFlex jcSpaceBetween aiCenter mb-5">
                <div className="consolidatedDataIcon dFlex">
                  <DamageLossBlack />
                </div>
                <div className="consolidateDataText">
                  Damage Loss Amount <small>BDT</small>
                </div>
                <div className="consolidateData">
                  {currencyFormatter(
                    editChallanData.products.reduce((sum, p) => {
                      const unitCost = parseFloat(p.amount || 0) / parseFloat(p.quantity || 1)
                      return sum + (unitCost * parseInt(p.quantity || 0))
                    }, 0)
                  )}
                </div>
              </div>
              
              {/* Editable Challan Number */}
              <div className="formGroup formFloating mb-4">
                <input
                  type="text"
                  className="formControl"
                  id="editChallanNumber"
                  placeholder="Challan Number"
                  value={editChallanData.challan_number}
                  onChange={(e) => handleEditChallanNumberChange(e.target.value)}
                  required
                />
                <label htmlFor="editChallanNumber">Challan Number</label>
                {challanNumberError && (
                  <div className="invalidFeedback">{challanNumberError}</div>
                )}
              </div>
              
              <div className="viewDetailSection mb-4">
                <div className="viewDetailLabel">Date</div>
                <div className="viewDetailValue">{formatDate(selectedChallanData.created_at)}</div>
              </div>
              
              {/* Editable Products */}
              <div className="viewDetailSection mb-4">
                <div className="viewDetailLabel">Products ({editChallanData.products.length})</div>
                <div className="editProductsList">
                  {editChallanData.products.map((product, idx) => (
                    <div key={idx} className="editProductItem mb-3">
                      <div className="productName mb-2">
                        {product.product_name}
                        {product.dose ? ` (${product.dose})` : ''}
                        {product.strength ? `-${product.strength}` : ''}
                      </div>
                      <div className="productEditFields dFlex aiCenter">
                        <div className="formGroup formFloating fgrow1 mb-0">
                          <input
                            type="number"
                            className="formControl"
                            id={`editQty-${idx}`}
                            placeholder="Quantity"
                            value={product.quantity}
                            onChange={(e) => handleEditProductQuantity(idx, e.target.value)}
                            min="1"
                          />
                          <label htmlFor={`editQty-${idx}`}>Quantity</label>
                        </div>
                        <div className="productCost ml-3">
                          Cost: BDT {currencyFormatter(
                            (parseFloat(product.amount || 0) / parseFloat(selectedChallanData.products[idx]?.quantity || 1)) * parseInt(product.quantity || 0)
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Editable Notes */}
              <div className="formGroup formFloating mb-4">
                <textarea
                  rows="2"
                  className="formControl"
                  id="editNotes"
                  placeholder="Notes"
                  value={editChallanData.notes}
                  onChange={(e) => handleEditNotesChange(e.target.value)}
                  required
                ></textarea>
                <label htmlFor="editNotes">Notes</label>
              </div>

              {/* Action Buttons */}
              {permissions?.features?.[PERMISSION_FEATURE.DAMAGE_LOSS] === PERMISSION_TYPE.MANAGE && (
                <div className="editActionWrap mt-5">
                  <div className="actionButtons dFlex">
                    <button
                      className="btn btnDanger dFlex aiCenter jcCenter"
                      onClick={() => setShowDeleteConfirm(true)}
                      disabled={isSaving}
                    >
                      <TrashIcon /> <span className="ml-2">Delete</span>
                    </button>
                    <button
                      className="btn btnPrimary dFlex aiCenter jcCenter ml-3"
                      onClick={handleSaveDamageLoss}
                      disabled={isSaving || !!challanNumberError}
                    >
                      {isSaving ? 'Saving...' : 'Save'}
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            // Add Mode Content
            <>
          <ul class="WizardStepsWrap">
            {/* <li className={`wizardStep`}>
                            <div class="circle">1</div>
                        </li>
                        <li className={`wizardStep`}>
                            <div class="circle">2</div>
                        </li>
                        <li className={`wizardStep`}>
                            <div class="circle">3</div>
                        </li> */}
          </ul>
          <div className="wizardFieldset">
            {serverError && (
              <div class="invalidFeedback mb-4">{serverError}</div>
            )}
            <div className="consolidateStrip dFlex jcSpaceBetween aiCenter mb-5">
              <div className="consolidatedDataIcon dFlex">
                <DamageLossBlack />
              </div>
              <div className="consolidateDataText">
                Damage Loss Amount <small>BDT</small>
              </div>
              <div className="consolidateData">
                {getTotalDamageLossAmount() > 0
                  ? getTotalDamageLossAmount()
                  : '---'}
              </div>
            </div>
            <form>
              <div className="formGroup formFloating fgrow1">
                <input
                  type="text"
                  className="formControl"
                  id="invoice"
                  placeholder="Challan Number"
                  value={damageLossData?.[DAMAGE_LOSS_FIELDS.CHALLAN_NUMBER]}
                  onChange={(e) => handleChallanNumberChange(e.target.value)}
                  required
                />
                <label for="invoice">Challan Number</label>
                {challanNumberError && (
                  <div class="invalidFeedback">
                    {challanNumberError}
                  </div>
                )}
                {isFieldErrorVisible &&
                  !damageLossData?.[DAMAGE_LOSS_FIELDS.CHALLAN_NUMBER] && !challanNumberError && (
                    <div class="invalidFeedback">
                      Please enter a Challan Number.
                    </div>
                  )}
              </div>
              <div className="formSection">
                <div className="formGroup formFloating fgrow1">
                  <input
                    type="text"
                    className="formControl"
                    id="invoice"
                    placeholder="Product Barcode/QR Code"
                    value={damageLossData?.[DAMAGE_LOSS_FIELDS.BARCODE] || ''}
                    onChange={(e) =>
                      handleDamageLossDetailUpdate(
                        DAMAGE_LOSS_FIELDS.BARCODE,
                        e.target.value
                      )
                    }
                    onBlur={(e) => getProductDetailsByBarcode()}
                    required
                  />
                  <label for="invoice">Product Barcode/QR Code</label>
                  {isFieldErrorVisible &&
                    (!damageLossData?.[DAMAGE_LOSS_FIELDS.BARCODE] ||
                      !productData?.product_id) && (
                      <div class="invalidFeedback">
                        Please enter a valid Product Barcode/QR Code.
                      </div>
                    )}
                  <div
                    className="positionedIcon"
                    onClick={() => setIsScannerVisible(!isScannerVisible)}
                  >
                    <BarcodeIcon />
                  </div>
                  {isScannerVisible && <BarcodeScanner onScan={handleScan} />}
                </div>
              </div>
              <div className="formGroup formFloating">
                <ReactSelect
                  className="formSelect reactSelect"
                  id="floatingSelect"
                  value={{
                    label: productData ? `${productData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_NAME] || ''}${productData?.[PRODUCT_DETAIL_FIELDS.DOSE] ? ` (${productData[PRODUCT_DETAIL_FIELDS.DOSE]})` : ''}${productData?.strength ? `-${productData.strength}` : ''}${productData?.category ? `-${productData.category}` : ''}` : '',
                  }}
                  // readonly={props?.isBarcodeDisabled}
                  onInputChange={
                    (option) => {
                      if (option) setSearchTerm(option)
                    }
                    // handleBillDetailUpdate(
                    //     BILL_DETAILS_FIELDS.PHARMA_COMPANY,
                    //     option
                    // )
                  }
                  onChange={(option) => {
                    setSelectedSearchTerm(option?.id)
                  }}
                  options={searchSuggestions}
                  getOptionLabel={(option) => `${option.label || option.name || ''}${option.dose ? ` (${option.dose})` : ''}${option.strength ? `-${option.strength}` : ''}${option.category ? `-${option.category}` : ''}`}
                  placeholder="Product Name"
                  styles={{
                    control: (base) => ({
                      border: 0,
                      display: 'flex',
                      paddingTop: '20px',
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused
                        ? 'rgb(222, 235, 255)'
                        : state.isSelected
                          ? '#FFF'
                          : 'inherit',
                      color: '#212529',
                      '&:hover': {
                        backgroundColor: state.isSelected
                          ? '#DEEBFF'
                          : 'rgb(222, 235, 255)',
                      },
                    }),
                  }}
                  // isClearable
                />
                <label for="floatingSelect">Product Name</label>
                {isFieldErrorVisible &&
                  !productData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_NAME] && (
                    <div className="invalidFeedback">Product Name.</div>
                  )}
              </div>
              <div className="formGroup formFloating">
                <ReactSelect
                  className="formSelect reactSelect"
                  id="floatingSelect"
                  value={
                    damageLossData?.[
                      PRODUCT_DETAIL_FIELDS.SELECTED_BATCH_DETAILS
                    ] || ''
                  }
                  onChange={(option) => {
                    handleDamageLossDetailUpdate(
                      'product_batch_inventory_id',
                      option?.product_batch_inventory_id
                    )
                    handleDamageLossDetailUpdate(
                      PRODUCT_DETAIL_FIELDS.SELECTED_BATCH_DETAILS,
                      option
                    )
                  }}
                  options={productData?.inventory || []}
                  getOptionLabel={(option) =>
                    `Batch: ${option?.[PRODUCT_DETAIL_FIELDS.BATCH_NUMBER]}, 
                                        Expiry: ${formatDate(
                                          option?.[
                                            PRODUCT_DETAIL_FIELDS.EXPIRY_DATE
                                          ]
                                        )}
                                        `
                  }
                  placeholder="Select Product Batch"
                  styles={{
                    control: (base) => ({
                      border: 0,
                      display: 'flex',
                      paddingTop: '20px',
                    }),
                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isFocused
                        ? 'rgb(222, 235, 255)'
                        : state.isSelected
                          ? '#FFF'
                          : 'inherit',
                      color: '#212529',
                      '&:hover': {
                        backgroundColor: state.isSelected
                          ? '#DEEBFF'
                          : 'rgb(222, 235, 255)',
                      },
                    }),
                  }}
                />
                <label for="floatingSelect">Select Product Batch</label>
                {isFieldErrorVisible &&
                  !damageLossData?.[
                    PRODUCT_DETAIL_FIELDS.SELECTED_BATCH_DETAILS
                  ]?.product_batch_inventory_id && (
                    <div className="invalidFeedback">
                      Please Select Product Batch.
                    </div>
                  )}
                {damageLossData?.[
                  PRODUCT_DETAIL_FIELDS.SELECTED_BATCH_DETAILS
                ] && (
                  <div className="inputSuggestionsWrap">
                    <ul className="inputSuggestion dFlex">
                      <li className="suggestion">
                        Selected Batch Stock:{' '}
                        {
                          damageLossData?.[
                            PRODUCT_DETAIL_FIELDS.SELECTED_BATCH_DETAILS
                          ]?.[PRODUCT_DETAIL_FIELDS.STOCK]
                        }
                      </li>
                    </ul>
                  </div>
                )}
              </div>
              {/* <div className="formGroup formFloating">
                                <select
                                    className="formSelect"
                                    id="floatingSelect"
                                    disabled={true}>
                                    <option
                                        value="none"
                                        selected
                                        disabled
                                        hidden>
                                        {
                                            productData?.[
                                                PRODUCT_DETAIL_FIELDS
                                                    .PRODUCT_NAME
                                            ]
                                        }
                                    </option>
                                    {/* <option value="1">Product Name 1</option>
                                    <option value="2">Product Name 2</option> */}
              {/*} </select>
                                <label for="floatingSelect">Product Name</label>
                                {false && (
                                    <div class="invalidFeedback">
                                        Please choose Product Name.
                                    </div>
                                )}
                            </div> */}
              <div className="formInline dFlex flexNowrap">
                <div className="formGroup formFloating fgrow1">
                  <input
                    type="text"
                    className="formControl"
                    id="quantity"
                    placeholder="Quantity"
                    value={damageLossData?.[DAMAGE_LOSS_FIELDS.QUANTITY]}
                    onChange={(e) =>
                      handleDamageLossDetailUpdate(
                        DAMAGE_LOSS_FIELDS.QUANTITY,
                        e.target.value
                      )
                    }
                    required
                  />
                  <label for="Quantity">Quantity</label>
                  {isFieldErrorVisible &&
                    (!damageLossData?.[DAMAGE_LOSS_FIELDS.QUANTITY] ||
                      parseInt(
                        damageLossData?.[PRODUCT_DETAIL_FIELDS.QUANTITY]
                      ) >
                        parseInt(
                          damageLossData?.[
                            PRODUCT_DETAIL_FIELDS.SELECTED_BATCH_DETAILS
                          ]?.[PRODUCT_DETAIL_FIELDS.STOCK]
                        )) && (
                      <div class="invalidFeedback">
                        Please select a valid Quantity.
                      </div>
                    )}
                </div>
                <div className="formGroup formFloating ml-4 fgrow1">
                  <input
                    type="text"
                    className="formControl"
                    id="dose"
                    placeholder="Dose"
                    value={
                      productData
                        ? productData?.[PRODUCT_DETAIL_FIELDS.DOSE]
                        : ''
                    }
                    disabled={true}
                    required
                  />
                  <label for="Dose">Dose</label>
                  {false && (
                    <div class="invalidFeedback">
                      Please select a valid Dose.
                    </div>
                  )}
                </div>
              </div>
              <div className="formSection dFlex mb-5">
                <div class="formCheck">
                  <input
                    class="formCheckInput"
                    type="radio"
                    name="flexRadioDefault"
                    id="Pharmaceutical"
                    disabled={true}
                    checked={
                      productData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_CATEGORY] ===
                      PRODUCT_CATEGORY.PHARMACEUTICAL
                    }
                  />
                  <label class="formCheckLabel" for="Pharmaceutical">
                    Pharmaceutical
                  </label>
                </div>
                <div class="formCheck ml-5">
                  <input
                    class="formCheckInput"
                    type="radio"
                    name="flexRadioDefault"
                    id="nPharmaceutical"
                    disabled={true}
                    checked={
                      productData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_CATEGORY] ===
                      PRODUCT_CATEGORY.NON_PHARMACEUTICAL
                    }
                  />
                  <label class="formCheckLabel" for="nPharmaceutical">
                    Non-Pharmaceutical
                  </label>
                </div>
                {false && (
                  <div class="invalidFeedback">
                    Please select Product Category.
                  </div>
                )}
              </div>
              <div className="formGroup formFloating formInputText">
                <div className="preInputGroup backColor">
                  <div className="preInputText">BDT</div>
                </div>
                <input
                  type="text"
                  className="formControl"
                  id="cost_unit"
                  placeholder="Cost/Unit"
                  value={
                    damageLossData?.[
                      PRODUCT_DETAIL_FIELDS.SELECTED_BATCH_DETAILS
                    ]?.[PRODUCT_DETAIL_FIELDS.PRODUCT_COST] || ''
                  }
                  disabled={true}
                  required
                />
                <label for="address">Cost/Unit</label>
                {false && (
                  <div className="invalidFeedback">Please enter BDT.</div>
                )}
              </div>
              <div className="addProductBtnWrap dFlex jcEnd mt-4 mb-4">
                <button
                  type="button"
                  className="btn btnSecondary addProductBtn dFlex aiCenter"
                  onClick={handleAddProductToList}
                >
                  <AddIcon /> <span className="ml-2">Add Product</span>
                </button>
              </div>
            </form>
            {productsList.length > 0 && (
              <div className="addedProductsList mt-4 mb-4">
                <div className="addedProductsHeader mb-2">
                  <strong>Added Products ({productsList.length})</strong>
                </div>
                {productsList.map((item, index) => (
                  <div key={item.id} className="addedProductItem dFlex jcSpaceBetween aiCenter mb-2">
                    <div className="productInfo">
                      <div className="productName">
                        {item.productData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_NAME] || ''}
                        {item.productData?.[PRODUCT_DETAIL_FIELDS.DOSE] ? ` (${item.productData[PRODUCT_DETAIL_FIELDS.DOSE]})` : ''}
                        {item.productData?.strength ? `-${item.productData.strength}` : ''}
                      </div>
                      <div className="productDetails">
                        Qty: {item.damageLossData?.[DAMAGE_LOSS_FIELDS.QUANTITY]} | 
                        Cost: BDT {(item.productData?.[PRODUCT_DETAIL_FIELDS.PRODUCT_NEW_COST] || 0) * (item.damageLossData?.[DAMAGE_LOSS_FIELDS.QUANTITY] || 0)}
                      </div>
                    </div>
                    <div className="removeProductBtn pointer" onClick={() => handleRemoveProductFromList(item.id)}>
                      <TrashIcon />
                    </div>
                  </div>
                ))}
              </div>
            )}
            {isFieldErrorVisible && productsList.length === 0 && (
              <div className="invalidFeedback mb-4">Please add at least one product.</div>
            )}
          </div>
          <div className="wizardFieldset">
            <form>
              <div className="formGroup formFloating">
                <textarea
                  rows="2"
                  type="text"
                  className="formControl"
                  id="notes"
                  value={damageLossData?.[DAMAGE_LOSS_FIELDS.NOTES]}
                  onChange={(e) =>
                    handleDamageLossDetailUpdate(
                      DAMAGE_LOSS_FIELDS.NOTES,
                      e.target.value
                    )
                  }
                  required
                ></textarea>
                <label for="notes">Notes</label>
                {isFieldErrorVisible &&
                  !damageLossData?.[DAMAGE_LOSS_FIELDS.NOTES] && (
                    <div class="invalidFeedback">Please enter notes.</div>
                  )}
              </div>
            </form>
          </div>
            </>
          )}
        </SideDrawer>

        {/* Delete Confirmation Popup */}
        {showDeleteConfirm && editChallanData && (
          <div className="deletePopupOverlay">
            <PopupCard
              header={`Delete Challan ${editChallanData.challan_number}`}
              body={`Are you sure you want to permanently delete this Damage/Loss record for challan ${editChallanData.challan_number}? This action cannot be undone.`}
            >
              <button
                className="btn btnPrimaryOutlined dFlex"
                onClick={() => setShowDeleteConfirm(false)}
                disabled={isDeleting}
              >
                Cancel
              </button>
              <button
                className="btn btnDanger dFlex"
                onClick={handleDeleteDamageLoss}
                disabled={isDeleting}
              >
                {isDeleting ? 'Deleting...' : 'Delete'}
              </button>
            </PopupCard>
          </div>
        )}
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    alert: state.alertReducer.alert,
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addDamageLossAlertAction: (payload) =>
      dispatch(addDamageLossAlertAction(payload)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DamageLoss)
